// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
import amplitude from 'amplitude-js';
const EmailsApi = ApiFactory.get('emails');

const fetchAll = async ( { commit }, qs ) => {
  const { data } = await EmailsApi.getAll(qs);
  commit('SET_DATA', data);
};

const create = async ( { commit }, payload ) => {
  const { data } = await EmailsApi.post(payload);
  amplitude.getInstance().logEvent('CREATE_EMAIL');
  commit('PUSH_DATA', data);
};

export default {
  fetchAll,
  create
};
